import { Action } from 'acscp/actions';

export class UpdatePushNotificationChannelSubscriptions extends Action {}
